import { Type, type Static } from "@fastify/type-provider-typebox";

export const CreateAddressBody = Type.Object({
  name: Type.String(),
  company: Type.Optional(Type.String()),
  address1: Type.String(),
  address2: Type.Optional(Type.String()),
  city: Type.String(),
  state: Type.String(),
  country: Type.Optional(Type.String()),
  zipcode: Type.String(),
  phone: Type.Optional(Type.String()),
  email: Type.Optional(Type.String()),
});
export type CreateAddressBody = Static<typeof CreateAddressBody>;

export const CreateAddressResponse = Type.Object({
  id: Type.Integer(),
});
export type CreateAddressResponse = Static<typeof CreateAddressResponse>;

export const PatchAddressBody = Type.Object({
  id: Type.Integer(),
  name: Type.Optional(Type.String()),
  company: Type.Optional(Type.String()),
  address1: Type.Optional(Type.String()),
  address2: Type.Optional(Type.String()),
  city: Type.Optional(Type.String()),
  state: Type.Optional(Type.String()),
  country: Type.Optional(Type.String()),
  zipcode: Type.Optional(Type.String()),
  phone: Type.Optional(Type.String()),
  email: Type.Optional(Type.String()),
});
export type PatchAddressBody = Static<typeof PatchAddressBody>;

// https://developer-docs.amazon.com/sp-api/docs/fulfillment-inbound-api-v2024-03-20-reference#address
// @TODO rename this to just 'Address'
export const AmazonAddress = Type.Object({
  addressLine1: Type.String({ minLength: 1, maxLength: 180 }),
  addressLine2: Type.Optional(Type.String({ minLength: 1, maxLength: 60 })),
  city: Type.String({ minLength: 1, maxLength: 30 }),
  companyName: Type.Optional(Type.String({ minLength: 1, maxLength: 50 })),
  email: Type.Optional(Type.String({ minLength: 1, maxLength: 1024 })),
  name: Type.String({ minLength: 1, maxLength: 50 }),
  phoneNumber: Type.Optional(Type.String({ minLength: 1, maxLength: 20 })),
  postalCode: Type.String({ minLength: 1, maxLength: 32 }),
  stateOrProvinceCode: Type.String({ minLength: 1, maxLength: 64 }),
});
export type AmazonAddress = Static<typeof AmazonAddress>;


// https://developer-docs.amazon.com/sp-api/docs/fulfillment-inbound-api-v2024-03-20-reference#addressinput
// @NOTE compared to above:
// - country code is required here, and not existant above
// - phone is required here, and optional above
// - stateOrProvinceCode is optional here, but required above
// - all the mins and maximums are the same
export const AddressInput = Type.Object({
  addressLine1: Type.String({ minLength: 1, maxLength: 180 }),
  addressLine2: Type.Optional(Type.String({ minLength: 1, maxLength: 60 })),
  city: Type.String({ minLength: 1, maxLength: 30 }),
  companyName: Type.Optional(Type.String({ minLength: 1, maxLength: 50 })),
  countryCode: Type.String({ minLength: 2, maxLength: 2, pattern: "^[A-Z]{2}$" }),
  email: Type.Optional(Type.String({ minLength: 1, maxLength: 1024 })),
  name: Type.String({ minLength: 1, maxLength: 50 }),
  phoneNumber: Type.String({ minLength: 1, maxLength: 20 }),
  postalCode: Type.String({ minLength: 1, maxLength: 32 }),
  stateOrProvinceCode: Type.Optional(Type.String({ minLength: 1, maxLength: 64 })),
});
export type AddressInput = Static<typeof AddressInput>

export enum Priority {
  CRITICAL = 1,
  HIGH = 2,
  MEDIUM = 3,
  LOW = 4,
}

